"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSOLoginComponent = void 0;
var tslib_1 = require("tslib");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var classnames_1 = require("../../util/classnames");
var page_1 = require("../../page/page");
var auth_component_style_1 = require("./auth.component.style");
(0, theme_1.addStyles)(auth_component_style_1.Style);
var SSOLoginComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SSOLoginComponent, _super);
    function SSOLoginComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SSOLoginComponent.prototype.viewButton = function () {
        return (0, mithril_1.m)('button', {
            className: (0, classnames_1.classNames)('mdl-button', 'mdl-button--raised', auth_component_style_1.CSS.button),
            onclick: function () { return services_1.Services.SSO.login(); }
        }, (0, i18n_1.Translate)(i18n_1.T.LOGIN_WITH_AUTH0));
    };
    Object.defineProperty(SSOLoginComponent.prototype, "nodes", {
        get: function () {
            // remove the flash of the login screen as the user is authenticating!
            // the ui renders before the sso authenticate state resolves, so without
            // this it feels janky.
            if (services_1.Services.SSO.inFlight || services_1.Services.SSO.isAuthenticated) {
                return (0, mithril_1.m)('div', {
                    className: auth_component_style_1.CSS.container
                }, (0, mithril_1.m)('div', {
                    className: auth_component_style_1.CSS.centered
                }, spinner_1.Spinner.view()));
            }
            return (0, mithril_1.m)('div', {
                className: auth_component_style_1.CSS.container
            }, [
                (0, mithril_1.m)('div', {
                    className: auth_component_style_1.CSS.text
                }, (0, mithril_1.m)('div', {
                    className: auth_component_style_1.CSS.textInner
                }, (0, i18n_1.Translate)(i18n_1.T.LOGIN_OFFICE))),
                (0, mithril_1.m)('div', {
                    className: auth_component_style_1.CSS.padding
                }, this.viewButton()),
                (0, mithril_1.m)('div', {
                    className: auth_component_style_1.CSS.padding
                }, (0, mithril_1.m)('a', {
                    className: auth_component_style_1.CSS.link,
                    onclick: function () { return services_1.Services.Route.go(page_1.IkePageName.userSSOMigrate); }
                }, (0, i18n_1.Translate)(i18n_1.T.LOGIN_NO_AUTH0_ACCOUNT)))
            ]);
        },
        enumerable: false,
        configurable: true
    });
    return SSOLoginComponent;
}(mithril_component_1.IMithrilComponent));
exports.SSOLoginComponent = SSOLoginComponent;
//# sourceMappingURL=login.js.map